<template>
  <main>
    <AppHeader />

    <NodeEditorial v-if="node" v-bind="node" />
    <div v-else>
      <PageHeader title="Page not found" />
    </div>

    <AppFooter :channel="activeChannel" />
  </main>
</template>

<script lang="ts" setup>
const language = useCurrentLanguage()
const { activeChannel } = useSiteContext()

const { data: node } = await useCachedAsyncData(
  'page-not-found-' + language.value,
  async () =>
    useGraphqlQuery('get404Page', null, {
      graphqlCaching: {
        client: true,
      },
    }),
  {
    deep: false,
    transform: (data) => data.data.get404Page,
    serverMaxAge: 60 * 60 * 24,
    serverCacheTags: (data) => data.extensions?.cacheability?.tagsNuxt || [],
    dedupe: 'defer',
    watch: [language],
  },
)

useCDNHeaders((cdn) => {
  // cache 404 for a short time.
  cdn.setNumeric('maxAge', 60)
})
</script>
